import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'

const getAnalytics = async (token, endpoint, params) => {
  const url = `admin/analytics/${endpoint}`
  const data = await apiGet({ url, token, params })
  return data
}

export function useAdminAnalyticsSummary({ params, options } = {}) {
  const token = useContext(AuthContext)
  const queryFn = () => getAnalytics(token, 'summary', params)
  const queryKey = ['admin-analytics-summary', params]
  return useQuery(queryKey, queryFn, { ...options })
}

// Generic hook used by both time-series and breakdown chart components.
export function useAdminAnalyticsTimeSeries({ endpoint, params, options } = {}) {
  const token = useContext(AuthContext)
  const queryFn = () => getAnalytics(token, endpoint, params)
  const queryKey = ['admin-analytics', endpoint, params]
  return useQuery(queryKey, queryFn, { ...options })
}

// Alias kept so that breakdown chart components share the same cache key
// structure while remaining semantically named at the call site.
export const useAdminAnalyticsBreakdown = useAdminAnalyticsTimeSeries
